function normalizePart(part: string | number): string {
  return String(part)
    .trim()
    .replace(/[^a-zA-Z0-9._:-]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

export function createRequestId(prefix: string = "req"): string {
  const safePrefix = normalizePart(prefix || "req") || "req";

  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return `${safePrefix}-${crypto.randomUUID()}`;
  }

  const timestamp = Date.now().toString(36);
  const random = Math.random().toString(36).slice(2, 10);
  return `${safePrefix}-${timestamp}-${random}`;
}

export function getOrCreateRequestId(
  existing: string | null | undefined,
  prefix: string = "req"
): string {
  if (existing && existing.trim().length > 0) {
    return existing.trim();
  }
  return createRequestId(prefix);
}

export function createIdempotencyKey(
  scope: string,
  ...parts: Array<string | number | null | undefined>
): string {
  const normalizedScope = normalizePart(scope || "op") || "op";
  const stableParts = parts
    .filter((part): part is string | number => part !== null && part !== undefined)
    .map((part) => normalizePart(part))
    .filter((part) => part.length > 0);

  const randomTail = createRequestId("idem").replace(/^idem-/, "");
  if (stableParts.length === 0) {
    return `${normalizedScope}:${randomTail}`;
  }

  return `${normalizedScope}:${stableParts.join(":")}:${randomTail}`;
}
